<script lang="ts">
  import Vue from "vue"
  import {TFeatureIds} from "~/interfaces/featuresInterfaces";

  export default Vue.extend({
    name: "feature",
    props: {
      tag: {
        type: String,
        default: 'div',
      },
      id: {
        type: String as () => TFeatureIds,
        required: true,
      },
    },
    render(createElement) {
      if (this.$feature.isOn(this.id)) {
        return createElement(this.tag, {
          class: 'experimental',
          on: this.$listeners,
        }, this.$slots.default)
      }
    },
  })
</script>
